import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Calendar, Clock, MapPin, Users, ExternalLink } from "lucide-react";
import { EVENTI_FULL } from "@/data/eventiData";

const DETTAGLI = {
  "dalla-teoria-alla-pratica-strumenti-esg-per-le-pmi": {
    descrizione: "Un nuovo appuntamento del progetto Green Business ideato da Confcommercio Roma e realizzato con il contributo della Camera di Commercio di Roma, pensato per accompagnare le imprese nel passaggio dalla riflessione alla pratica operativa sui temi ESG.\n\nQuesto evento è dedicato alla messa a terra concreta dei principi di sostenibilità, con un focus specifico sulla Governance come leva di competitività e creazione di valore per le PMI del terziario.\n\nL'iniziativa unisce laboratori operativi, momenti di confronto e casi reali, offrendo strumenti applicabili e occasioni di networking.",
    ora: "17:30", location: "Rome Business School - Via Giuseppe Montanelli, 5, 00195 Roma",
    programma: [
      "Benvenuto e Saluti Istituzionali — Romolo Guasco, Direttore Confcommercio Roma; Massimo Scarcello, Associate Dean Rome Business School",
      "Inquadramento e introduzione — Andrea Fassi, consigliere Gruppo Giovani Imprenditori Confcommercio Roma",
      "L'impatto delle imprese virtuose sul territorio: i risultati di un workshop Confcommercio Roma e Rome Business School — Mina Distratis, Design Thinker e Prof. Valerio Mancini, Direttore Centro di Ricerca",
      "Tavola Rotonda — Prof. Valerio Mancini; Luigi Corvo, CEO Open Impact; Imprenditori del mondo Confcommercio. Modera: Giovanni De Carli, Sinkronie | Happy to Business",
      "Chiusura dei lavori — Antonio Ragusa, Dean Rome Business School",
    ],
    collegati: [{ titolo: "Green Business: Il bilancio di sostenibilità per le PMI di Roma e Regione Lazio", url: "/progetti" }],
    cta: { label: "Iscriviti su Eventbrite", url: "https://www.eventbrite.it/e/biglietti-green-business-dalla-teoria-alla-pratica-strumenti-esg-per-le-pmi-1980080971488" },
  },
  "roma-la-bellezza-al-centro": {
    descrizione: "Un evento speciale che segna la chiusura dei progetti camerali 'Splendori del Giubileo' e 'Tridente Moda District', raccontato attraverso un talk show dedicato al valore, alle potenzialità e alle complessità del Centro Storico di Roma, con un focus sul sito Tridente Moda District, una piattaforma digitale interattiva pensata per ospitare itinerari personalizzati tra boutique, beni culturali e ristorazione gourmet.\n\nL'evento è pubblico e si svolgerà online in diretta streaming sui canali Facebook e YouTube.\n\nUn appuntamento digitale pensato per raccontare, confrontarsi e condividere visioni sul presente e sul futuro del Centro Storico, attraverso le voci dei suoi protagonisti.",
    ora: "18:00", location: "In streaming sulla pagina Facebook e sul profilo YouTube di Confcommercio Roma",
    programma: [
      "Apertura lavori con video di presentazione",
      "Saluti di benvenuto e introduzione — Romolo Guasco, Direttore Confcommercio Roma",
      "Parte 1 | Progetto 'Splendori del Giubileo: Arte sacra e antiquariato' — Talk: la forza della tradizione",
      "Parte 2 | Progetto 'Tridente Moda District' — Talk: prospettive future del Centro Storico di Roma. Con: Mariano Angelucci (Presidente XII Commissione Roma Capitale), Fabrizio Russo (Presidente Centro Storico), Grazia Marino (Ass. Via Margutta), Valerio Lucci (Ass. Via Condotti), Onorio Rebecchini (Presidente Convention Bureau Roma e Lazio)",
      "Presentazione Tridente Moda District — Maddalena Salerno (CEO Bla Studio), Ana Gabriela Llrin (AANT), Anna Giova (Wyl)",
      "Saluti finali",
    ],
    collegati: [{ titolo: "Tridente Moda District", url: "/progetti" }, { titolo: "Splendori del Giubileo", url: "/progetti" }],
  },
  "agenti-ai-pmi-webinar-gratuito-11-dicembre": {
    descrizione: "In un mercato in continua evoluzione, le imprese si trovano di fronte alla sfida di integrare tecnologie innovative per rimanere competitive. E qui che entrano in gioco gli Agenti AI, software progettati per automatizzare compiti, analizzare dati e interagire con clienti e processi aziendali, agendo come veri e propri 'colleghi digitali'.\n\nA differenza dei software tradizionali, possono prendere decisioni, pianificare azioni, interagire con l'ambiente e apprendere dall'esperienza, con un intervento umano minimo. Utilizzano tecnologie come i modelli linguistici di grandi dimensioni (LLM) e l'elaborazione del linguaggio naturale per comprendere le istruzioni.\n\nUn'occasione per capire da dove partire e fare il primo passo verso l'adozione dell'AI in azienda.",
    ora: "14:30 - 16:00", location: "Online", partecipazione: "Libera",
    approfondimenti: ["Automatizzazione dei compiti ripetitivi: liberare tempo prezioso per attività a maggior valore aggiunto", "Miglioramento del servizio clienti: offrire risposte immediate e personalizzate", "Analisi dati per decisioni aziendali: trasformare i dati in insight strategici", "Supporto alle operazioni quotidiane: ottimizzare i processi interni e ridurre gli errori", "Primo passo nell'adozione degli agenti AI: una guida pratica per iniziare"],
    programma: [
      "Avvio Webinar e Moderazione — Andreas Schwalm, EDI | 14:30",
      "Agenti AI per PMI: i tuoi nuovi colleghi digitali — Pietro Bonomo, CEO Marketing Hackers, AI Automation Designer | 14:50",
      "Sessione di Q&A | 15:50",
      "Chiusura Webinar | 16:00",
    ],
    nota: "Il webinar è realizzato nell'ambito del programma formativo EDI Training: il digitale come booster per l'impresa e del Progetto CATCH atMIND.",
    cta: { label: "Iscriviti al webinar", url: "https://training.ediconfcommercio.it/enrol/index.php?id=153" },
  },
  "il-giubileo-del-gusto-presentazione-dellitinerario-dei-sapori": {
    descrizione: "Evento finale del progetto 'Il Giubileo del Gusto', realizzato e promosso da FIPE Confcommercio Roma, con il contributo della Camera di Commercio di Roma e il patrocinio dell'Assessorato alle Attività Produttive di Roma Capitale.\n\nDurante l'evento Excellence Food Innovation verranno raccontate le fasi e i risultati del progetto e premiati i vincitori del contest, protagonisti delle video interviste dal media partner The Roman Post. Con quattro di loro approfondiremo le sfide e le opportunità di fare impresa a Roma nel settore della ristorazione, e l'impatto che il Giubileo 2025 ha avuto sulla loro attività.\n\nSarà inoltre presentato l'Itinerario dei Sapori, la mappa digitale e cartacea che raccoglie le 12 tappe dove assaggiare i piatti proposti e reinterpretati per il Giubileo.\n\nL'evento si svolge all'interno di Excellence Food Innovation, una delle principali manifestazioni a Roma dedicate all'enogastronomia. I partecipanti avranno accesso gratuito alla manifestazione e potranno visitare liberamente le aree espositive al termine dell'incontro.",
    ora: "15:00", location: "Officine Farneto, Via dei Monti della Farnesina, 77, Roma", partecipazione: "Gratuita su registrazione",
    programma: [
      "Saluti istituzionali — Sergio Paolantoni, Presidente FIPE Confcommercio Roma",
      "Presentazione del progetto — Francesco Cianfarani, The Roman Post | Core Comunicazione; Lavinia Scafi, Er Romano",
      "Tavola rotonda 'Roma, impresa under 45: sfide di oggi, visioni di domani' — Modera: Andrea Paolantoni, Vice Presidente Gruppo Giovani Confcommercio Roma",
      "Premiazione dei 12 protagonisti del progetto",
      "Conclusioni",
    ],
    collegati: [{ titolo: "Il Giubileo del Gusto", url: "/progetti" }],
    cta: { label: "Registrati all'evento", url: "https://forms.gle/f45hifEU3AbWwK6W7" },
  },
};

export default function EventoDettaglioPage() {
  const { slug } = useParams();
  const evento = EVENTI_FULL.find((e) => e.slug === slug);

  if (!evento) {
    return (
      <main id="main-content" className="py-20 text-center">
        <h1 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-4">Evento non trovato</h1>
        <Link to="/eventi" className="text-[var(--confcom-blue)] font-medium hover:underline">Torna agli eventi</Link>
      </main>
    );
  }

  const dettaglio = DETTAGLI[slug];
  const originalUrl = `https://www.confcommercioroma.it/eventi/${slug}/`;

  return (
    <main id="main-content" data-testid="evento-dettaglio">
      {/* Hero */}
      <section className="relative h-[300px] md:h-[380px] overflow-hidden">
        <img src={evento.image} alt={evento.titolo} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(4,30,66,0.9), rgba(4,30,66,0.4))" }} />
        <div className="absolute bottom-0 left-0 right-0 z-10">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-8">
            <Link to="/eventi" className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white mb-3 transition-colors" data-testid="evento-back">
              <ArrowLeft size={16} /> Tutti gli eventi
            </Link>
            <div className="flex items-center gap-3 mb-3">
              <span className="text-xs font-medium text-[var(--confcom-blue)] bg-white px-2.5 py-1 rounded-md">{evento.tipo}</span>
            </div>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight leading-tight" data-testid="evento-titolo">
              {evento.titolo}
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Immagine evento */}
          <div className="mb-10 rounded-xl overflow-hidden border border-[var(--confcom-border)]">
            <img src={evento.image} alt={evento.titolo} className="w-full h-auto" />
          </div>
          <div className="grid lg:grid-cols-3 gap-10">
            {/* Main */}
            <div className="lg:col-span-2">
              {dettaglio ? (
                <>
                  {dettaglio.descrizione.split("\n\n").map((p, i) => (
                    <p key={i} className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">{p}</p>
                  ))}
                  {dettaglio.approfondimenti && (
                    <div className="mb-8 mt-8">
                      <h2 className="text-xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-4">Cosa approfondiremo</h2>
                      <ul className="space-y-3">
                        {dettaglio.approfondimenti.map((item, i) => (
                          <li key={i} className="flex items-start gap-3 text-sm text-[var(--confcom-text-secondary)]">
                            <span className="w-6 h-6 bg-[var(--confcom-bg-blue-light)] rounded-full flex items-center justify-center text-[var(--confcom-blue)] text-xs font-bold shrink-0">{i + 1}</span>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {dettaglio.nota && (
                    <p className="text-sm text-[var(--confcom-text-muted)] italic mb-6 p-4 bg-[var(--confcom-bg-subtle)] rounded-lg">{dettaglio.nota}</p>
                  )}
                  {dettaglio.programma && (
                    <div className="mb-8">
                      <h2 className="text-xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-5">Programma</h2>
                      <div className="space-y-3">
                        {dettaglio.programma.map((item, i) => (
                          <div key={i} className="flex items-start gap-3 p-4 bg-[var(--confcom-bg-subtle)] rounded-lg">
                            <span className="w-6 h-6 bg-[var(--confcom-blue)] rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0">{i + 1}</span>
                            <span className="text-sm text-[var(--confcom-text-secondary)]">{item}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {dettaglio.collegati && dettaglio.collegati.length > 0 && (
                    <div className="mt-8 pt-6 border-t border-[var(--confcom-border)]">
                      <h3 className="text-base font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-3">Contenuti collegati</h3>
                      <div className="space-y-2">
                        {dettaglio.collegati.map((c) => (
                          <Link key={c.titolo} to={c.url} className="block text-sm text-[var(--confcom-blue)] hover:underline">{c.titolo}</Link>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="p-6 bg-[#EBF5FF] rounded-xl mb-8">
                  <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">Per visualizzare tutti i dettagli, il programma completo e le modalita di iscrizione a questo evento, visita la pagina originale.</p>
                  <a href={originalUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-medium hover:opacity-90 transition-opacity text-sm">
                    Vai alla pagina dell'evento <ExternalLink size={16} aria-hidden="true" />
                  </a>
                </div>
              )}
              {!dettaglio && (
                <a href={originalUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-medium text-[var(--confcom-blue)] hover:underline">
                  Vedi su confcommercioroma.it <ExternalLink size={14} aria-hidden="true" />
                </a>
              )}
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-2xl border border-[var(--confcom-border)] p-6 sticky top-[104px] lg:top-[168px]">
                <h3 className="text-lg font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-5">Dettagli evento</h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <Calendar size={18} className="text-[var(--confcom-blue)] shrink-0 mt-0.5" aria-hidden="true" />
                    <div>
                      <div className="text-xs text-[var(--confcom-text-muted)]">Data</div>
                      <div className="text-sm font-medium text-[var(--confcom-text-primary)]">{evento.data}</div>
                    </div>
                  </div>
                  {dettaglio?.ora && (
                    <div className="flex items-start gap-3">
                      <Clock size={18} className="text-[var(--confcom-blue)] shrink-0 mt-0.5" aria-hidden="true" />
                      <div>
                        <div className="text-xs text-[var(--confcom-text-muted)]">Orario</div>
                        <div className="text-sm font-medium text-[var(--confcom-text-primary)]">{dettaglio.ora}</div>
                      </div>
                    </div>
                  )}
                  {dettaglio?.location && (
                    <div className="flex items-start gap-3">
                      <MapPin size={18} className="text-[var(--confcom-blue)] shrink-0 mt-0.5" aria-hidden="true" />
                      <div>
                        <div className="text-xs text-[var(--confcom-text-muted)]">Location</div>
                        <div className="text-sm font-medium text-[var(--confcom-text-primary)]">{dettaglio.location}</div>
                      </div>
                    </div>
                  )}
                  {dettaglio?.partecipazione && (
                    <div className="flex items-start gap-3">
                      <Users size={18} className="text-[var(--confcom-blue)] shrink-0 mt-0.5" aria-hidden="true" />
                      <div>
                        <div className="text-xs text-[var(--confcom-text-muted)]">Partecipazione</div>
                        <div className="text-sm font-medium text-[var(--confcom-text-primary)]">{dettaglio.partecipazione}</div>
                      </div>
                    </div>
                  )}
                </div>
                {dettaglio?.cta && (
                  <div className="mt-6 pt-6 border-t border-[var(--confcom-border)]">
                    <a href={dettaglio.cta.url} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full py-3 rounded-xl text-sm font-semibold text-white bg-[var(--confcom-blue)] hover:opacity-90 transition-opacity">
                      {dettaglio.cta.label} <ExternalLink size={14} aria-hidden="true" />
                    </a>
                  </div>
                )}
                {!dettaglio?.cta && (
                  <div className="mt-6 pt-6 border-t border-[var(--confcom-border)]">
                    <a href={originalUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full py-3 rounded-xl text-sm font-semibold text-white bg-[var(--confcom-blue)] hover:opacity-90 transition-opacity">
                      Dettagli e iscrizione <ExternalLink size={14} aria-hidden="true" />
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
